import { AccountOrderDetailPage } from "@/components/account/orders/detail/page"

export function generateStaticParams() {
  // Return placeholder for build validation
  // Actual order pages are generated dynamically
  return [{ number: "0" }]
}

interface PageProps {
  params: Promise<{ number: string }>
}

export default async function MinhaContaPedidoDetailPage({
  params,
}: PageProps) {
  const { number } = await params

  return <AccountOrderDetailPage orderNumber={number} />
}
